import { render, staticRenderFns } from "./SectionHelpCenter.vue?vue&type=template&id=03a56e72&scoped=true"
import script from "./SectionHelpCenter.vue?vue&type=script&lang=ts"
export * from "./SectionHelpCenter.vue?vue&type=script&lang=ts"
import style0 from "./SectionHelpCenter.vue?vue&type=style&index=0&id=03a56e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a56e72",
  null
  
)

export default component.exports